import { XIcon } from "@components/atoms/Icons/components/x-icon";
import { CircleCheckIcon } from "@components/atoms/Icons/index";
import { Transition } from "@headlessui/react";
import { translate } from "@locales";
import { Fragment } from "react";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export function NewsletterPopup({ isOpen, onClose }: Props) {
  return (
    <Transition appear show={isOpen} as="div">
      <div className="fixed top-0 right-0 z-[1055] h-full w-full overflow-y-auto overflow-x-hidden outline-none">
        <div className="flex min-h-screen">
          <div className="fixed inset-y-20 right-0 flex w-full sm:w-[512px]">
            <Transition.Child
              as={Fragment}
              enter="transform transition ease-in-out duration-500 sm:duration-700"
              enterFrom={"translate-x-full"}
              enterTo="translate-x-0"
              leave="transform transition ease-in-out duration-500 sm:duration-700"
              leaveFrom="translate-x-0"
              leaveTo={"translate-x-full"}
            >
              <div className="relative bg-white w-[335px] lg:w-[489px] h-[157px] lg:h-[150px] px-4 py-6 border-2 shadow-xl ml-6 lg:ml-0">
                <div className="absolute top-0 right-0 mr-[23px] mt-[24px]">
                  <button onClick={onClose}>
                    <XIcon
                      height="15px"
                      width="15px"
                      className="text-gray-500 hover:text-gray-700"
                    />
                  </button>
                </div>
                <div className="flex flex-row justify-center">
                  <div className="mr-4 lg:mr-[30px]">
                   
                    <CircleCheckIcon className="w-8 h-8 sm:w-16 sm:h-16" height={""} width={""} />
                  </div>
                  <div className="flex flex-col w-[312px]">
                    <h1 className="font-chivo-black-italic text-xl mb-3 uppercase">
                      {translate("suscribe.popup.title")}
                    </h1>
                    <p className="text-dark-gray font-chivo-regular text-xs lg:text-base">
                      {translate("suscribe.popup.description")}
                    </p>
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </div>
      </div>
    </Transition>
  );
}
